import { FormVmItemConfigType } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { EVENTS_BASE_FORM_CONFIG } from '../_events-base/events-base.config';

export {
    ENABLED,
    LABEL,
    DISPLAY_LABEL,
    DESCRIPTION,
    DISPLAY_SPEAKERS,
    LAYOUT,
    DEFAULT_VIEW,
    DISPLAY_UPCOMING_EVENTS,
    UPCOMING_EVENTS_DAYS,
    DISPLAY_PAST_EVENTS,
    PAST_EVENTS_DAYS,
    POSITION_ORDER,
    MIN_EVENTS_DAYS,
    MAX_EVENTS_DAYS,
    DEFAULT_UPCOMING_EVENTS_DAYS,
    DEFAULT_PAST_EVENTS_DAYS,
} from '../_events-base/events-base.config';

const FORM_CONFIG = {
    ...EVENTS_BASE_FORM_CONFIG,
};

export const EVENTS_MODULE_CONFIG: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
